import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import styles from "./AccountGift.module.scss"
import classNames from 'classnames/bind';



const cx = classNames.bind(styles)
const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: "#007687",
		color: theme.palette.common.white,
	}
}))(TableCell);


const useStyles = makeStyles({
	root: {
		width: '100%',
		border: "1px solid #007687",
		boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25)"
	},
	// container: {
	// 	maxHeight: 440,
	// 	"&::- webkit - scrollbar": {
	// 		borderRadius: 0,
	// 		width: 8,
	// 	},

	// 	"&:: -webkit - scrollbar - thumb": {
	// 		borderRadius: 4,
	// 		backgroundColor: "rgba(0, 0, 0, 0.15)",
	// 	},

	// 	"&:: -webkit - scrollbar - track": {
	// 		borderRadius: 0,
	// 		backgroundColor: "rgba(0, 0, 0, 0)"
	// 	}
	// },
});

export default function CustomTable({ title, rows, ...props }) {
	const { t } = useTranslation();

	const classes = useStyles();
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<Paper className={classes.root}>
			<TableContainer
				// className={classes.container}
				className={cx('table')}
			>
				<Table stickyHeader aria-label="sticky table">
					<TableHead>
						<TableRow>
							{title.map((column) => (
								<StyledTableCell
									key={column.id}
									align={column.align}
									style={{ minWidth: column.minWidth }}
								>
									{column.label}
								</StyledTableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
							return (
								<TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
									{title.map((column) => {
										const value = row[column.id];
										return (
											column.id === 'stt' ?
												<TableCell key={column.id} align={column.align}>
													{index + 1}
												</TableCell> :
												<TableCell key={column.id} align={column.align}>
													{column.format && typeof value === 'number' ? column.format(value) : value}
												</TableCell>
										);
									})}
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[10, 25, 100]}
				component="div"
				count={rows.length}
				rowsPerPage={rowsPerPage}
				labelRowsPerPage={<div>{t('account.gift_page.number')}</div>}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</Paper>
	);
}
